import { числаБоя } from './fight-numbers.js';
import { ЧАСТОТА } from './species-kinds.js';
import { ПЛАНИРУЕМЫЕ } from './species-planned.js';
export const FISH_ORDER = ПЛАНИРУЕМЫЕ.map((x) => x.id);
/**
 * Четыре железки, которые понимает нынешний движок.
 *
 * ⚠️ ОБЪЯВЛЕНО ВЫШЕ ТАБЛИЦЫ, И ПЕРЕСТАВЛЯТЬ НЕЛЬЗЯ. Таблица собирается ПРИ
 * ЗАГРУЗКЕ МОДУЛЯ, а объявленная через const постоянная до своей строки недоступна вовсе — не пустая, а
 * именно недоступна. Стояло ниже: сборка падала с «Cannot access before
 * initialization», и падала не при вызове, а при первом же ввозе файла, то есть
 * игра не открывалась совсем.
 */
/**
 * Железо спиннинга. Всё, чего здесь нет, — наживка удочки.
 *
 * ⚠️ ОТБОРА ПО НЕМУ В ПРАВИЛАХ БОЛЬШЕ НЕТ, И ВЫВЕЗЕН ОН РАДИ ДРУГОГО: по
 * нему снаряжение отличает спиннинговый комплект от удочного, а лавка —
 * раздел приманок от раздела наживки. Держать второй такой список рядом
 * значило бы однажды забыть дописать в него новую железку.
 */
export const ЖЕЛЕЗО = new Set(['spinner', 'wobbler', 'spoon', 'jig']);
/** Наживка ли это. Обратное — железо. */
export function наживкаЛи(чем) {
    return !ЖЕЛЕЗО.has(чем);
}
/**
 * Числа четырёх играющих видов.
 *
 * ⚠️ ТАБЛИЦА БОЛЬШЕ НЕ ПИШЕТСЯ РУКАМИ, А ВЫВОДИТСЯ ИЗ СПРАВОЧНИКА. Здесь лежали
 * четыре записи по семнадцать полей, набранные вручную, — и ровно те же виды
 * описаны в справочнике на две сотни рыб. Два места об одном расходятся: правку
 * веса или горизонта делали в одном, а второе оставалось со старым, и заметить
 * это можно было только сверив глазами.
 *
 * Теперь правда одна. Числа боя даёт правило (fight-numbers.ts), всё остальное
 * берётся из записи вида. Проверено: выведенная таблица совпадает с прежней
 * рукописной побайтно, кроме двух намеренных перемен — см. ниже.
 *
 * ⚠️ ДОБАВИТЬ РЫБУ В ИГРУ ТЕПЕРЬ — ЭТО ДВЕ СТРОКИ И МОДЕЛЬ. Дописать ключ в
 * FishKind и в FISH_ORDER; всё прочее у вида уже записано. Раньше пришлось бы
 * сочинять семнадцать чисел заново.
 *
 * ⚠️ ИГРАЮТ ПОКА ЧЕТВЕРО, И ОГРАНИЧИВАЕТ ЭТО НЕ СПРАВОЧНИК, А ОТСУТСТВИЕ
 * ТРЁХМЕРНЫХ МОДЕЛЕЙ. Рыбу без модели нельзя ни показать в воде, ни положить на
 * мель — beachLieM считает по её полутолщине, а рисовать нечего.
 */
export const FISH_KINDS = Object.fromEntries(FISH_ORDER.map((k) => [k, собратьВид(k)]));
/**
 * Собрать описание играющего вида из записи справочника.
 *
 * ⚠️ РЯД «ЧЕМ БЕРЁТСЯ» ПЕРЕНОСИТСЯ ЦЕЛИКОМ, И ЭТО ТОТ САМЫЙ ОБЕЩАННЫЙ ШАГ.
 * Здесь стоял отбор: из семи строк щуки брали четыре железные, а живца, резку
 * и лягушку выбрасывали — движок не понимал наживки. Выброшенное было не
 * мелочью: из 1134 строк справочника железо составляет 279, всё остальное —
 * наживка. Две трети видов не брали НИЧЕГО и не ловились вовсе.
 *
 * Теперь ряд переносится как есть. Ни одного числа заново не пишется: они
 * записаны у видов давно и ждали удочки.
 */
function собратьВид(k) {
    const в = ПЛАНИРУЕМЫЕ.find((x) => x.id === k);
    if (в === undefined)
        throw new Error(`вида ${k} нет в справочнике`);
    const ч = { ...числаБоя(в), ...в.поправки };
    const lure = {};
    for (const строка of в.чем)
        lure[строка.чем] = строка.вес;
    return {
        kind: k,
        minKg: в.minKg,
        maxKg: в.maxKg,
        typicalKg: в.typicalKg,
        typicalLengthM: в.typicalLengthM,
        halfThickFrac: ч.halfThickFrac,
        когда: в.когда,
        редкость: в.редкость,
        depthM: в.depthM,
        depthBandM: в.depthBandM,
        lure,
        speedMps: ч.speedMps,
        speedBandMps: ч.speedBandMps,
        windowS: ч.windowS,
        hookMps: ч.hookMps,
        strength: ч.strength,
        lipHoldN: ч.lipHoldN,
        staminaS: ч.staminaS,
        jumpRate: ч.jumpRate,
    };
}
/**
 * Границы зон нагрузки в долях предела снасти.
 *
 * ⚠️ ОДНО ЧИСЛО НА ПОКАЗ И НА УРОН. Порог, с которого кольцо краснеет, и
 * порог, с которого рвётся губа, обязаны совпадать — иначе прибор врёт.
 * Так и было: кольцо краснело с 0.8, а рваться начинало только с 1.0, и в
 * красной зоне несколько секунд не происходило ровно ничего. Игрок либо
 * переставал верить цвету, либо отпускал фрикцион, когда было ещё рано.
 *
 * Живут здесь, а не в приборе, потому что число это про СНАСТЬ, а прибор
 * его только показывает.
 */
export const LOAD_WARN_FRAC = 0.55;
export const LOAD_RED_FRAC = 0.8;
const gauss = (x, band) => Math.exp(-(x * x) / (2 * band * band));
/**
 * Мельче этого рыбы не бывает вовсе, м.
 *
 * Полметра — это лужа: крупной рыбе там не развернуться, а мелочь на таком
 * месте не держится, потому что её саму видно с берега и сверху. Ниже этой
 * отметки поклёвок нет ни у кого, сколько бы правильной ни была приманка.
 */
export const MIN_BITE_DEPTH_M = 0.5;
/**
 * Сколько своих длин рыбе нужно иметь под собой, чтобы стоять на месте.
 *
 * ⚠️ ОДНО ЧИСЛО ВМЕСТО ТРЁХ ПОРОГОВ, И ОНО ИХ ВОСПРОИЗВОДИТ. Просили
 * «крупная за −1.5, средняя за −1, мелкая от −0.5» — но задавать это тремя
 * ступенями значило бы, что на 1.49 м трофея нет, а на 1.51 он появляется
 * из ниоткуда. Мешает рыбе не глубина сама по себе, а СОБСТВЕННЫЙ РАЗМЕР:
 * метровой щуке негде развернуться там, где двадцатисантиметровому окуню
 * простор.
 *
 * Двойка проверена ровно по тем порогам, что и просили:
 *   0.5 м → рыба до 25 см — это окунь до трёхсот граммов;
 *   1.0 м → до 50 см — судак и мелкая щука;
 *   1.5 м → до 75 см — щука под три килограмма;
 *   3.0 м → полтора метра, то есть кто угодно.
 *
 * ⚠️ ПРАВИЛО ОДНОСТОРОННЕЕ. Глубина задаёт ПОТОЛОК размера, а не дно:
 * мелочь клюёт и на глубине тоже. «Вдали клюёт и мелкая, и средняя, и
 * крупная» получается само — глубже становится ВСЁ, что помещалось мельче.
 */
const DEPTH_PER_LENGTH = 2;
/**
 * Самая крупная рыба этого вида, которая может стоять на такой глубине, кг.
 *
 * Длина считается из веса кубическим корнем (см. lengthFor), поэтому
 * обратный ход — куб: вдвое глубже значит вдесятеро тяжелее.
 */
export function maxWeightForDepth(spec, waterDepthM) {
    const fitsLengthM = waterDepthM / DEPTH_PER_LENGTH;
    return spec.typicalKg * (fitsLengthM / spec.typicalLengthM) ** 3;
}
/**
 * Единица на первой доле отрезка, ноль на остальной, со сглаженными краями.
 *
 * `u` — доля 0..1, `share` — какая часть занята единицей, `ramp` — ширина
 * перехода в тех же долях. Нужна, чтобы заход рыбы начинался и кончался
 * плавно: ступенька в силе дёргала бы полосу нагрузки, и по ней ничего
 * нельзя было бы прочесть.
 */
function smoothBand(u, share, ramp) {
    const step = (x) => {
        const t = Math.max(0, Math.min(1, x));
        return t * t * (3 - 2 * t);
    };
    return step(u / ramp) * (1 - step((u - share) / ramp));
}
/**
 * Насколько это место и эта проводка нравятся виду, 0..1.
 *
 * Произведение, а не сумма, и это важно. Слагаемые прощают промах:
 * поставил джиг вместо вертушки — общая оценка просела, но клёв остался.
 * Множители не прощают: судак на поверхности не берёт НИЧЕГО, сколько бы
 * ни было правильным всё остальное. Так оно и есть на воде.
 */
export function speciesMatch(spec, c) {
    // ⚠️ ГЛУБИНА — ВОРОТА, А НЕ МНОЖИТЕЛЬ. Ниже полуметра рыбы нет никакой:
    // это не «клюёт хуже», это лужа, и никакая приманка тут не поможет.
    if (c.waterDepthM < MIN_BITE_DEPTH_M)
        return 0;
    const depth = gauss(c.lureDepthM - spec.depthM, spec.depthBandM);
    // Нет строки в ряду — вид на это не берётся вовсе, и это ноль, а не
    // «неизвестно»: ряд справочника полон по замыслу (см. FishSpec.lure).
    const lure = spec.lure[c.lureKind] ?? 0;
    // Стоящую приманку хищник тоже берёт, но хуже — кроме джига, у которого
    // пауза и есть проводка.
    const speed = c.retrieving
        ? gauss(c.retrieveMps - spec.speedMps, spec.speedBandMps)
        : c.lureKind === 'jig'
            ? 0.7
            : 0.25;
    // ⚠️ МЕСТО РЕШАЕТ НЕ «ЕСТЬ ЛИ ТУТ ВИД», А «КАКАЯ ЕГО ЧАСТЬ ТУТ
    // ПОМЕЩАЕТСЯ».
    //
    // Стояло отношение глубины к любимому горизонту вида — то есть про место
    // спрашивали у СРЕДНЕЙ рыбы, а рыбы разного размера в одном виде
    // отличаются вдесятеро. Выходило, что на метровой отмели щука клюёт с той
    // же вероятностью девятикилограммовая, что и полукилограммовая.
    //
    // Считаем долю весового ряда вида, которая на этой глубине помещается —
    // и в ЛОГАРИФМЕ, потому что сам ряд логнормальный (см. rollWeight): от
    // сорока граммов до килограмма у окуня «расстояние» такое же, как от
    // килограмма до девяти у щуки. Тогда на полуметре щуки нет вовсе (не
    // помещается даже самая мелкая), окунь берёт вполсилы, а с трёх метров
    // помещаются все и место перестаёт мешать кому бы то ни было.
    const fitsKg = maxWeightForDepth(spec, c.waterDepthM);
    if (fitsKg <= spec.minKg)
        return 0;
    const room = Math.min(1, Math.log(fitsKg / spec.minKg) / Math.log(spec.maxKg / spec.minKg));
    /*
     * ⚠️ СУТОЧНЫЙ ХОД СЧИТАЕТСЯ ЗДЕСЬ, А НЕ СНАРУЖИ, И ЭТО ВАЖНО ДЛЯ ВЫБОРА ВИДА.
     * Стоял он общим множителем в `conditionsFactor`, то есть одинаково давил на
     * всех — и на выбор «кто именно клюнул» не влиял вовсе. Внутри совпадения он
     * работает как надо: ночью вес судака растёт, вес окуня падает, и клюнувшим
     * скорее окажется судак. Ровно это и значит «ночью ловится другая рыба».
     */
    /*
     * ⚠️ РАЗМЕР ПРИМАНКИ РЕШАЕТ, КТО КЛЮНЕТ, А НЕ ТОЛЬКО КАКОГО РАЗМЕРА. Поле
     * `lureMassKg` приходило в этот разбор и НЕ ЧИТАЛОСЬ здесь вовсе: оно влияло
     * только на вес пойманной рыбы, отсекая снизу. Выходило, что тридцатиграммовая
     * колебалка собирает окуней ровно так же, как микроджиг, — просто окуни
     * получаются покрупнее.
     *
     * ⚠️ ОТСЕЧКА В `rollWeight` ПРИ ЭТОМ ОСТАЁТСЯ, И ЭТО НЕ ДВОЙНОЙ СЧЁТ. Здесь
     * решается, СТАНЕТ ЛИ ВИД брать такую приманку; там — какая рыба ВНУТРИ вида
     * на неё позарится. Убери отсечку — и на тридцатиграммовую колебалку начал бы
     * попадаться сорокаграммовый окунь, которому она с него самого.
     */
    const масса = gauss(Math.log(Math.max(1e-4, c.lureMassKg) / любимаяМасса(spec.typicalKg)), МАССА_ПОЛОСА);
    /*
     * ⚠️ РЕДКОСТЬ — ПОСЛЕДНИЙ МНОЖИТЕЛЬ, И ОНА НЕ ЗАМЕНЯЕТ ПРАВИЛА, А ДОБАВЛЯЕТСЯ
     * К НИМ. Белуга на озёрной отмели не клюнет вовсе, сколько ни сиди: её
     * множитель умножается на ноль от глубины. Редкость решает только то, как
     * часто вид попадается ТАМ, ГДЕ ОН ВООБЩЕ БЕРЁТ.
     */
    return (depth *
        lure *
        speed *
        room *
        масса *
        суточный(spec.когда, c.sunElevationDeg) *
        ЧАСТОТА[spec.редкость]);
}
/**
 * Любимая масса приманки для рыбы такого веса, кг.
 *
 * ⚠️ ЗАКОН, А НЕ ПОЛЕ В ЗАПИСИ ВИДА. Двести чисел, выдуманных поштучно,
 * выглядели бы замеренными; закон же читается вслух и проверяется по четвёрке.
 * Подобран по тому, чем этих рыб и правда ловят: окуню 5 г, судаку 16, щуке 18,
 * жереху 14. Показатель шесть десятых — приманка растёт МЕДЛЕННЕЕ рыбы: щука
 * тяжелее окуня в восемь раз, а её приманка — всего в три с половиной.
 *
 * ⚠️ НЕ ПУТАТЬ С ПРАВИЛОМ `lureMassKg * 12` ИЗ `rollWeight`. То — про наименьшую
 * рыбу, способную взять такую приманку; это — про самую охотную. Числа разные,
 * и подставь мы одно вместо другого, щуке досталась бы приманка в 117 граммов.
 */
function любимаяМасса(typicalKg) {
    return 0.015 * typicalKg ** 0.6;
}
/**
 * ⚠️ ШИРИНА ЗАДАНА В РАЗАХ, А НЕ В ГРАММАХ, И ИНАЧЕ БЫТЬ НЕ МОЖЕТ. Приманки в
 * игре от грамма до двухсот — разброс в двести раз; полоса «плюс-минус пять
 * граммов» для уклейки была бы всей её жизнью, а для сома неразличимой мелочью.
 * Мерить надо кратностью: приманка вдвое тяжелее любимой — это одно и то же
 * отклонение и для уклейки, и для сома.
 *
 * Два с половиной раза — примерно ступень между соседними размерами в коробке.
 */
const МАССА_ПОЛОСА = Math.log(2.5);
/**
 * Суточный ход клёва — СВОЙ У КАЖДОГО ВИДА.
 *
 * ⚠️ БЫЛА ОДНА КРИВАЯ НА ВСЕХ, И ЭТО БЫЛА ПРЯМАЯ НЕПРАВДА. Зори кормили,
 * полдень был хуже, ночь совсем плоха — у всех разом. Из этого следовало, что
 * ночью хуже клюёт и судак, у которого в глазу отражающий слой и который ночью
 * как раз и кормится; и сом, кормящийся только в темноте. Игрок, вышедший ночью
 * за судаком, получал наказание за верное решение.
 *
 * ⚠️ ВСЕ ЧЕТЫРЕ КРИВЫЕ ДАЮТ ОДИНАКОВОЕ СУТОЧНОЕ СРЕДНЕЕ, И ЭТО ГЛАВНОЕ В НИХ.
 * Нормировка подобрана так, что за сутки каждый вид набирает столько же, сколько
 * набирал по общей кривой. Меняется КОГДА, а не СКОЛЬКО: ночная рыба не стала
 * реже, она переехала на ночь. Без нормировки ночные виды просто стали бы
 * малочисленнее, и это выглядело бы как правка баланса, а не как правда о рыбе.
 *
 * ⚠️ НОЧЬ ШИРОКАЯ И ГЛУБОКАЯ — ЦЕНТР НА −30°, А НЕ НА −18°. С прежней узкой
 * полосой в глубокую ночь (солнце на −55°) не доставало ничего, и «ночная» рыба
 * получала пол — те же 0.25, что и дневная. То есть ночной вид ночью не клевал.
 */
const СУТОЧНЫЕ = {
    // Пик на зорях острый, день ровный, ночь почти глухая: щука, окунь, жерех.
    дневная: { зори: 1.2, день: 1.3, ночь: 0.05, норма: 0.825 },
    // Кормится в темноте, в полдень стоит: судак, сом, налим, угорь.
    ночная: { зори: 1.15, день: 0.08, ночь: 1.3, норма: 0.842 },
    // Самый острый пик на зорях — это и есть прежняя общая кривая: лещ, карп.
    сумеречная: { зори: 1.75, день: 0.7, ночь: 0.3, норма: 1 },
    // Ясной привязки нет: ход пологий, но зори всё равно чуть лучше.
    круглосуточная: { зори: 1, день: 0.85, ночь: 0.75, норма: 0.812 },
};
/**
 * ⚠️ ПОЛ В ЧЕТВЕРТЬ ОСТАЁТСЯ, И ОН ЗДЕСЬ ВАЖНЕЕ, ЧЕМ БЫЛ. Без него ночная рыба
 * в полдень и дневная в полночь получали бы почти ноль, то есть «сегодня не
 * твой вид, приходи через двенадцать часов». Рыбалка так не устроена: клюёт
 * всегда хоть немного, просто хуже.
 */
const СУТОЧНЫЙ_ПОЛ = 0.25;
function суточный(когда, sunElevationDeg) {
    const к = СУТОЧНЫЕ[когда];
    const e = sunElevationDeg;
    const ход = к.зори * gauss(e - 2, 9) + к.день * gauss(e - 35, 26) + к.ночь * gauss(e + 30, 25);
    return Math.max(СУТОЧНЫЙ_ПОЛ, ход) * к.норма;
}
/**
 * Множитель условий, ОДИНАКОВЫХ ДЛЯ ВСЕХ ВИДОВ: небо и волна.
 *
 * ⚠️ ВРЕМЯ СУТОК ОТСЮДА УШЛО В `speciesMatch`, И ЭТО НЕ ПЕРЕКЛАДЫВАНИЕ. Оно
 * зависит от вида, а эта функция вида не знает и знать не должна: пасмурность и
 * волна действуют на всех одинаково. Оставь мы время здесь — пришлось бы либо
 * передавать сюда вид, либо считать его дважды.
 *
 * ⚠️ ВЫЗЫВАЮЩИМ МЕНЯТЬ НИЧЕГО НЕ НАДО. Произведение `speciesMatch × conditionsFactor`
 * осталось тем же по смыслу и по величине — время просто переехало из правого
 * множителя в левый. Поэтому и `biteRate`, и прибрежная рыба в мире продолжают
 * работать без правок.
 */
export function conditionsFactor(c) {
    // Пасмурно — хищник смелее: нет резких теней и слепящего света.
    const sky = 0.85 + 0.35 * c.cloudiness;
    // Небольшая волна размывает силуэт рыболова и мутит воду у берега.
    const wave = 0.85 + Math.min(0.4, c.waveHeightM * 2.2);
    return sky * wave;
}
/**
 * Базовая частота поклёвок, 1/с.
 *
 * Подобрана так, чтобы при среднем совпадении выходило около одной поклёвки
 * за восемь минут, а при идеальном — за две. Это соответствует спиннингу
 * на озере: рыбалка не про непрерывный клёв.
 */
/**
 * ⚠️ ПОДНЯТА ВЧЕТВЕРО ПРОТИВ ЧЕСТНОЙ. Восемь минут ожидания — это правда
 * про спиннинг на озере, и именно поэтому в игре так нельзя: игрок сидит
 * без единого события и не может ни научиться чему-то, ни проверить снасть.
 * Полторы-две минуты — тот шаг, на котором смена приманки или горизонта
 * ещё ощущается как решение, а не как ожидание.
 */
/**
 * ⚠️ ПОДНЯТА ВТРОЕ ВМЕСТЕ С ВВОДОМ РЕДКОСТИ И РАЗМЕРА ПРИМАНКИ, И ЭТО НЕ
 * ПОСЛАБЛЕНИЕ. Оба новых множителя меньше единицы: редкость режет частоту по
 * ступеням, размер приманки — по отклонению от любимой. На развёртке по времени,
 * глубине, приманке и массе они вместе дали 0.339 от прежнего клёва.
 *
 * Оставь мы базу как была — вышло бы, что мы не «сделали редкую рыбу редкой», а
 * просто сделали рыбалку втрое скучнее, и половина игроков решила бы, что игра
 * сломалась. Множитель 2.95 возвращает СУММАРНУЮ частоту к прежней; меняется
 * только то, КТО клюёт и НА ЧТО.
 *
 * Пересчитывать при каждой правке этих множителей: стенд в test/_bal показывает
 * отношение новой суммы к старой одной строкой.
 */
/**
 * ⚠️ И ПОДНЯТА ВДВОЕ СВЕРХ ТОГО — ПО ПРЯМОМУ РЕШЕНИЮ, А НЕ ПО РАСЧЁТУ. Было
 * 0.0248, стало 0.0496: клёв удвоен всем и везде. Прежние два пояснения выше
 * оставлены нарочно — они объясняют, из чего сложилось само число, и без них
 * следующая правка баланса пошла бы наугад.
 *
 * ⚠️ ПРАВИТЬ ТОЛЬКО ЗДЕСЬ, И ЭТО ВАЖНЕЕ САМОГО ЧИСЛА. По нему сервер
 * разыгрывает поклёвку, а клиент рисует «шанс X%» в строке снасти. Заведи
 * второе такое число где-нибудь ещё — и панель начнёт обещать одно, а
 * сервер выдавать другое; спорить при этом будет некому, потому что оба
 * честны по-своему.
 */
const BASE_RATE = 0.0496;
/**
 * Итоговая частота поклёвок в секунду и её разбор по слагаемым.
 *
 * @param allowed какие виды водятся в этом водоёме. Не задан — водятся все.
 *
 * ⚠️ СПИСОК ВОДОЁМА ОБЯЗАН ВХОДИТЬ И СЮДА, А НЕ ТОЛЬКО В ВЫБОР ВИДА.
 *
 * Раньше частота складывалась по ВСЕМУ справочнику, а список водоёма
 * применялся ниже, при розыгрыше вида (см. pickSpecies). Выходили две
 * неправды сразу. Первая: озеро с десятком видов клевало так же часто, как
 * если бы в нём жили все двести, — потому что сумма совпадений считалась по
 * всем. Вторая, и обиднее: клёв не отзывался на саму рыбу. Форелевое озеро
 * оживало в карповые часы и на карповую приманку, ведь в сумму входил карп,
 * которого там нет.
 *
 * Считать надо по тем же видам, что и выбирать, — иначе «в озере водится
 * вот это» остаётся надписью в лобби, а не правилом игры.
 *
 * ⚠️ ПУСТОЙ СПИСОК ДАЁТ НОЛЬ, И ЭТО ВЕРНО. Водоём, из которого сняли всю
 * рыбу, обязан молчать. Отдельной проверки для этого больше не нужно: сумма
 * совпадений нулевая, значит и частота нулевая.
 */
export function biteRate(c, allowed) {
    let best = 'perch';
    let bestMatch = 0;
    let sum = 0;
    for (const k of FISH_ORDER) {
        if (allowed !== undefined && !allowed.includes(k))
            continue;
        const m = speciesMatch(FISH_KINDS[k], c);
        sum += m;
        if (m > bestMatch) {
            bestMatch = m;
            best = k;
        }
    }
    const perSecond = BASE_RATE * sum * conditionsFactor(c);
    return { perSecond, best, match: sum };
}
/** Та же частота, выраженная как шанс за минуту — так её и читают. */
export function chancePerMinute(perSecond) {
    return 1 - (1 - Math.min(1, perSecond)) ** 60;
}
/**
 * Кто именно клюнул. Выбор взвешен по совпадению: где приманка идёт по
 * судаковому горизонту, судак и возьмёт.
 *
 * @param allowed какие виды водятся в этом водоёме. Не задан — водятся все.
 *
 * ⚠️ ОТБОР ИДЁТ ВЕСАМИ, А НЕ ПОВТОРНЫМ ЖРЕБИЕМ. Проще было бы тянуть жребий,
 * пока не выпадет разрешённый вид, — но в водоёме, где оставлен один жерех,
 * такая петля крутилась бы десятки раз на каждую поклёвку, а при опечатке в
 * списке не кончалась бы вовсе. Обнулённый вес решает то же и за один проход.
 *
 * ⚠️ ПУСТОЙ СПИСОК ЗДЕСЬ НЕ ОБРАБАТЫВАЕТСЯ НАМЕРЕННО. Водоём без рыбы — это
 * «не клюнуло», а не «клюнул окунь по умолчанию»; решать это должен тот, кто
 * раздаёт поклёвки, ещё до розыгрыша вида (см. bites.ts). Верни мы отсюда
 * запасной вид — в пустом озере ловилось бы, и галочки админа ничего не
 * значили бы.
 */
export function pickSpecies(c, rnd, allowed) {
    const weights = FISH_ORDER.map((k) => allowed !== undefined && !allowed.includes(k) ? 0 : speciesMatch(FISH_KINDS[k], c));
    const total = weights.reduce((a, b) => a + b, 0);
    if (total <= 0)
        return запасной(allowed);
    let acc = rnd * total;
    for (let i = 0; i < FISH_ORDER.length; i++) {
        acc -= weights[i];
        if (acc <= 0)
            return FISH_ORDER[i];
    }
    // Последний разрешённый, а не последний вообще: при заданном списке хвост
    // ряда может оказаться видом, которого в этом водоёме нет.
    for (let i = FISH_ORDER.length - 1; i >= 0; i--) {
        const k = FISH_ORDER[i];
        if (allowed === undefined || allowed.includes(k))
            return k;
    }
    return запасной(allowed);
}
/**
 * Кого вернуть, когда ни один вид не подошёл по условиям.
 *
 * ⚠️ ЗАПАСНЫМ БЫЛ ЖЁСТКО ОКУНЬ, И С ПОЯВЛЕНИЕМ СПИСКА ВИДОВ ЭТО СТАЛО ДЫРОЙ:
 * в водоёме, где админ оставил одну щуку, при неподходящей приманке всё равно
 * вылезал бы окунь — то есть галочки обходились бы сами собой. Берём первый
 * разрешённый; окунь остаётся запасным лишь там, где список не задан вовсе.
 */
function запасной(allowed) {
    if (allowed === undefined)
        return 'perch';
    for (const k of FISH_ORDER)
        if (allowed.includes(k))
            return k;
    return 'perch';
}
/**
 * Вес рыбы, кг.
 *
 * ⚠️ РАСПРЕДЕЛЕНИЕ ЛОГНОРМАЛЬНОЕ, А НЕ РОВНОЕ. Мелочи в водоёме на порядки
 * больше, чем трофеев, и ровный жребий между минимумом и максимумом дал бы
 * пятикилограммовых щук через одну. Логарифм сдвигает массу распределения
 * к типичному весу и оставляет крупной рыбе длинный редкий хвост.
 *
 * Крупная приманка отсекает мелочь: на десятисантиметровый воблер
 * стограммовый окунь не позарится. Это и есть смысл выбора веса приманки.
 *
 * ⚠️ ГЛУБИНА ОТСЕКАЕТ СВЕРХУ, И НЕ ОБРЕЗКОЙ, А СЖАТИЕМ РЯДА.
 *
 * `waterDepthM` задаёт потолок размера (см. maxWeightForDepth). Просто
 * обрезать по нему готовый жребий нельзя: половина рыб выходила бы ровно
 * потолочного веса, и на метровой отмели каждая вторая щука весила бы
 * восемьсот граммов до грамма. Поэтому потолок подставляется в сам
 * розыгрыш вместо максимума вида — весь ряд сжимается к мелкой стороне, и
 * распределение остаётся распределением.
 *
 * Отсюда и то, ради чего всё затевалось: у берега попадается мелочь, чуть
 * дальше средняя, а трофей — только там, где ему есть где стоять.
 */
export function rollWeight(spec, lureMassKg, rnd, rnd2, waterDepthM = Number.POSITIVE_INFINITY) {
    // Потолок не может опуститься ниже минимума вида: если вид сюда не
    // помещается вовсе, его сюда и не пустят (см. speciesMatch), а сюда мы
    // попадём только с уже проверенной глубиной.
    const capKg = Math.max(spec.minKg * 1.05, Math.min(spec.maxKg, maxWeightForDepth(spec, waterDepthM)));
    const lnMin = Math.log(spec.minKg);
    const lnMax = Math.log(capKg);
    // Типичная тоже уезжает вниз вместе с потолком, иначе на мели пик
    // распределения оказался бы за его пределами и все рыбы вышли бы
    // одинаковыми — у самого потолка.
    const lnTyp = Math.log(Math.min(spec.typicalKg, capKg * 0.85));
    // Треугольное в логарифме: пик на типичном, хвосты к границам.
    const u = rnd;
    const c = (lnTyp - lnMin) / (lnMax - lnMin);
    const ln = u < c
        ? lnMin + Math.sqrt(u * (lnMax - lnMin) * (lnTyp - lnMin))
        : lnMax - Math.sqrt((1 - u) * (lnMax - lnMin) * (lnMax - lnTyp));
    let kg = Math.exp(ln);
    // Отсечка снизу по приманке: рыба должна быть способна её взять.
    // Правило простое и рыбацкое — приманка около десятой доли веса рыбы
    // и мельче; на крупную мелочь просто не бросается.
    const floor = lureMassKg * 12;
    if (kg < floor)
        kg = floor + (kg - floor) * 0.25 + rnd2 * floor * 0.3;
    // Потолок последним словом: отсечку по приманке он тоже перебивает —
    // на мели крупной рыбы нет, какую приманку ни привяжи.
    return Math.max(spec.minKg, Math.min(capKg, kg));
}
/**
 * Насколько прилив сил возвращает рыбе свежесть, доли потерянного.
 *
 * ⚠️ ЭТО ВТОРОЕ ДЫХАНИЕ, А НЕ ПОБЛАЖКА. Выдохшаяся рыба у самого берега
 * вдруг находит запас и уходит обратно на глубину — это ровно тот момент,
 * на котором её чаще всего и теряют, и без него вываживание кончается
 * скучно: сила падает по прямой, и последняя треть боя решена заранее.
 *
 * Больше половины возвращать нельзя: тогда бой не кончался бы вовсе.
 * Половина — это «пошла как свежая», но ненадолго и с расплатой (см. расход
 * выносливости на приливе в stepFight).
 */
const SURGE_LIFT = 0.55;
/**
 * Насколько сильнее первый бросок и за сколько эта злость сходит, с.
 *
 * Полтора цикла заходов: две-три секунды рыба не понимает, что происходит,
 * и рвётся изо всех сил, потом начинает беречься.
 */
const FIRST_RUN_GAIN = 0.55;
const FIRST_RUN_TAU_S = 4;
/**
 * Гребень волны: доля полной тяги на рывке у свежей и у выдохшейся рыбы,
 * и показатель, с которым одно переходит в другое.
 *
 * Показатель меньше единицы делает кривую ВОГНУТОЙ: сила держится высоко
 * почти до конца и обрывается на последних крохах выносливости. Это и есть
 * «рвануть она может почти всегда».
 */
const CREST_SPENT = 0.22;
const CREST_POW = 0.6;
/**
 * Фон между рывками — те же доли, но кривая ВЫПУКЛАЯ (показатель больше
 * единицы): фон уходит быстро, и уже к середине боя между заходами рыба
 * почти висит. Отсюда и растущий разрыв между рывком и паузой.
 */
const FLOOR_FRESH = 0.26;
const FLOOR_SPENT = 0.04;
const FLOOR_POW = 1.8;
/**
 * Опорная длина рыбы, м: на ней период волны такой, каким был всегда.
 * Типичная щука, то удилище и та рыба, на которых отлажен весь бой.
 */
const WAVE_REF_LENGTH_M = 0.6;
/**
 * Границы того, во что рыба вкладывается в отдельный заход.
 *
 * ⚠️ БЕЗ ЭТОГО СЛЕДУЮЩАЯ ВОЛНА НИКОГДА НЕ БЫВАЕТ ВЫШЕ ПРЕДЫДУЩЕЙ. Всё
 * остальное в силе считается из выносливости, а она только убывает и убывает
 * гладко — значит и гребни шли гладко вниз, и бой читался с первых двух
 * волн. Живая рыба так себя не ведёт: она то поберечься решит, то выложится
 * вся, и предсказать это нельзя.
 *
 * Верхняя граница выше единицы намеренно: рыба МОЖЕТ выдать больше своего
 * нынешнего гребня, вложившись сверх меры, — и заплатит за это тем, что
 * следующий заход выйдет слабее.
 */
const WAVE_GAIN_MIN = 0.6;
const WAVE_GAIN_MAX = 1.3;
/** Случайная вкладка рыбы в очередной заход, WAVE_GAIN_MIN..WAVE_GAIN_MAX. */
export function rollWaveGain(rnd) {
    return WAVE_GAIN_MIN + (WAVE_GAIN_MAX - WAVE_GAIN_MIN) * Math.max(0, Math.min(1, rnd));
}
/**
 * Свежесть с учётом прилива сил, 0..1.
 *
 * ⚠️ ОДНО ПРАВИЛО НА ВСЕХ, КТО СПРАШИВАЕТ. Свежесть читают трое: сила тяги,
 * упор рыбы против подмотки и показ (крен на бок, частота хвоста). Посчитай
 * прилив в каждом по-своему — и рыба на экране ляжет на бок ровно тогда,
 * когда в расчёте она рванула.
 */
export function surgedFresh(rest, surge) {
    return rest + (1 - rest) * SURGE_LIFT * Math.max(0, Math.min(1, surge));
}
/**
 * Сила, с которой рыба тянет прямо сейчас, Н.
 *
 * ⚠️ УСТАЁТ ОНА ОТ РАБОТЫ ПРОТИВ ФРИКЦИОНА, А НЕ ОТ ВРЕМЕНИ.
 *
 * Это ключевое место всего вываживания и единственное, что делает фрикцион
 * настоящим выбором. Затянул туго — рыба выматывается быстро, но и леска
 * ближе к обрыву. Отпустил — леска цела, а рыба сматывает метры и не
 * устаёт вовсе. Настоящая рыбалка ровно про этот компромисс, и он выходит
 * сам, стоит связать выносливость с натяжением, а не с секундомером.
 *
 * `fightS` — секунды С МОМЕНТА ПОСАДКИ, и это важнее, чем кажется. Раньше
 * сюда шло общее время сеанса: цикл заходов крутился сам по себе, и рыба с
 * равной вероятностью садилась как в начале рывка, так и посреди передышки.
 * Во втором случае первые четыре секунды она не делала НИЧЕГО — та самая
 * «послушная» рыба, которая никуда не рвётся. С нуля же цикл начинается
 * заходом: подсёк — и сразу держи.
 *
 * `surge` 0..1 — прилив сил, см. SURGE_LIFT.
 * `runGain` — во что рыба вкладывается ИМЕННО В ЭТОТ заход, см. WAVE_GAIN.
 */
export function fightForceN(spec, massKg, staminaLeft, fightS, surge = 0, runGain = 1) {
    const rest = Math.max(0, Math.min(1, staminaLeft / staminaFor(spec, massKg)));
    // ⚠️ ПРИЛИВ СИЛ ПОДНИМАЕТ НЕ СИЛУ, А СВЕЖЕСТЬ — И ЭТИМ ПОДНИМАЕТ ВСЁ
    // СРАЗУ. Через свежесть считаются и сила, и длина захода, и его доля в
    // цикле. Умножь я на прилив одну готовую силу — вышел бы просто более
    // громкий рывок той же длины; а рыба на приливе идёт именно как более
    // свежая: дольше и злее. Одно число, и всё сходится само.
    const fresh = surgedFresh(rest, surge);
    // ⚠️ ЗАХОДЫ, А НЕ ШУМ. Стояли две несоизмеримые синусоиды — намеренно
    // так, чтобы не читался период. Но нечитаемый период означает, что игроку
    // НЕЧЕГО УГАДЫВАТЬ: рыба тянет ровным дрожанием, и решение «тянуть или
    // отпустить» принимать не по чему. Вываживание было не разговором, а
    // ожиданием.
    //
    // Настоящая рыба ходит заходами: рванула — идёт на пределе, выдохлась —
    // отдыхает, и в эту паузу её и подматывают. Отсюда весь ритм боя, и он
    // обязан быть ВИДЕН. Заход короче и реже по мере усталости — под конец
    // рыба уже почти не рвётся.
    //
    // ⚠️ ПЕРИОД ЗАВИСИТ ОТ РАЗМЕРА РЫБЫ, А НЕ ОДИН НА ВСЕХ. Девять секунд
    // стояли и у двухсотграммового окуня, и у девятикилограммовой щуки — а
    // выносливости окуня хватает на пять. Он выдыхался, не успев завершить
    // ОДИН заход: замерено, на весь бой одна волна. Никакого «мелочь ведёт
    // себя так же, только слабее» из этого выйти не могло.
    //
    // Время у тел одной формы идёт как корень из размера — так же считают
    // шаг животного и мах хвоста. Опорная рыба — типичная щука 60 см, на ней
    // всё и отлажено: у неё период остался прежним, у окуня стал вдвое
    // короче, у трофея — в четверть длиннее.
    const sizeS = Math.sqrt(lengthFor(spec, massKg) / WAVE_REF_LENGTH_M);
    const cycleS = (5 + 4 * fresh) * sizeS;
    const runShare = 0.25 + 0.3 * fresh;
    const u = ((fightS % cycleS) + cycleS) % cycleS;
    // Края сглажены: сила не должна прыгать ступенькой, иначе полоса нагрузки
    // дёргается и по ней ничего не прочесть.
    const ramp = 0.35;
    const inRun = smoothBand(u / cycleS, runShare, ramp / cycleS);
    // ⚠️ ГРЕБЕНЬ И ФОН УБЫВАЮТ ПО-РАЗНОМУ, И ЭТО ГЛАВНОЕ ЗДЕСЬ.
    //
    // Стоял один множитель (0.1 + 0.9·свежесть) на всю силу разом — то есть с
    // усталостью одинаково падали и рывки, и то, что между ними. Отсюда шла
    // ровная лестница вниз: замерено на щуке 3 кг, гребни 88 → 48 → 35 → 26 →
    // 20 → 15 → 11 → 7 → 6 → 6 Н, и НИ РАЗУ выше предыдущего. Последняя треть
    // боя — прямая линия: волн нет вовсе, мёртвый груз на леске.
    //
    // На воде иначе. Рыба выдыхается ФОНОМ: между рывками она провисает всё
    // сильнее и кажется сдавшейся. А рвануть она способна почти до самого
    // конца — просто всё реже и всё дороже. Потому здесь две разные кривые:
    //
    //   ГРЕБЕНЬ падает медленно, вогнуто: даже на исходе сил остаётся пятая
    //     часть полной тяги — это тот самый последний рывок у берега;
    //   ФОН падает быстро, выпукло: к середине боя между заходами почти
    //     ничего не остаётся.
    //
    // Разрыв между ними от этого только растёт: у свежей рыбы рывок вчетверо
    // выше фона, у выдохшейся — впятеро с лишним. Волны идут до конца.
    const crest = CREST_SPENT + (1 - CREST_SPENT) * fresh ** CREST_POW;
    const floor = FLOOR_SPENT + (FLOOR_FRESH - FLOOR_SPENT) * fresh ** FLOOR_POW;
    const wave = floor + Math.max(0, crest * runGain - floor) * inRun;
    // ⚠️ ПЕРВЫЙ БРОСОК — САМЫЙ СИЛЬНЫЙ, И ОН ОДИН ТАКОЙ. Рыба только что
    // почувствовала крючок и выкладывается целиком, ещё не зная, что впереди
    // долгий бой. Дальше она уже бережёт себя, и такой злости не будет до
    // самого конца. Убывает надбавка за пару заходов — ровно столько длится
    // это «не понимаю, что происходит».
    const firstRun = 1 + FIRST_RUN_GAIN * Math.exp(-fightS / FIRST_RUN_TAU_S);
    return massKg * 9.81 * spec.strength * wave * firstRun;
}
/**
 * На что рыба способна в лучший свой момент, Н.
 *
 * Опора для двух вещей сразу: с ней сравнивается натяжение, когда считается,
 * как быстро рыба выматывается, и по ней же видно, во сколько раз рыба
 * сильнее, чем держит её губа.
 */
export function ownForceN(spec, massKg) {
    return massKg * 9.80665 * spec.strength;
}
/**
 * Выносливость этой конкретной рыбы, с.
 *
 * ⚠️ ЗАВИСИТ ОТ ВЕСА, А НЕ ТОЛЬКО ОТ ВИДА. Стояла одна цифра на вид, и
 * стограммовый окунь упирался ровно столько же, сколько килограммовый —
 * пять секунд. Это неверно и обидно: мелочь должна вылетать сразу.
 *
 * Корень, а не прямая пропорция: вчетверо более тяжёлая рыба борется вдвое
 * дольше. Так и на воде — сила растёт быстрее выносливости, поэтому крупная
 * рыба берёт мощью, а не временем.
 */
export function staminaFor(spec, massKg) {
    return spec.staminaS * Math.sqrt(massKg / spec.typicalKg);
}
/**
 * Длина этой рыбы, м.
 *
 * ⚠️ ДЛИНА НЕ ЗАДАЁТСЯ ОТДЕЛЬНО, ОНА СЛЕДУЕТ ИЗ ВЕСА. Рыба растёт примерно
 * подобно себе: масса идёт как объём, то есть как куб длины. Значит длина —
 * кубический корень из веса, и другой она быть не может, иначе двухкилограммовая
 * щука оказалась бы либо колбасой, либо бочонком.
 *
 * Отсюда же и размер модели: одна и та же сетка, растянутая на длину. Списка
 * длин по видам нет и не нужно — есть одна опорная пара «типичный вес — его
 * длина», всё остальное считается.
 *
 * Проверка на настоящих рыбах: щука 9 кг → 112 см, окунь 1.3 кг → 43 см,
 * судак 6 кг → 85 см, жерех 4.5 кг → 77 см. Все четыре в пределах того, что
 * вынимают из воды.
 */
export function lengthFor(spec, massKg) {
    return spec.typicalLengthM * Math.cbrt(massKg / spec.typicalKg);
}
/** Плотность воды, кг/м³. */
const WATER_RHO = 1000;
/**
 * Сопротивление рыбы, которую ТАЩАТ, — коэффициент и боковая площадь.
 *
 * ⚠️ РЫБА НА КРЮЧКЕ ИДЁТ БОКОМ, А НЕ НОСОМ, И ЭТО РЕШАЕТ ВСЁ.
 *
 * Своим ходом рыба обтекаема — там Cd около 0.1, и по нему считается её
 * предельная скорость на рывке. Но крючок сидит в ПАСТИ, и тянут её за
 * голову вбок: тело встаёт поперёк потока, а поперёк это почти плоская
 * пластина, у которой Cd около 1.1. Девять десятых — небольшая скидка на
 * то, что рыба всё-таки не доска.
 */
const TOW_CD = 0.9;
/**
 * Тот же коэффициент у ВЫДОХШЕЙСЯ рыбы.
 *
 * ⚠️ БЕЗ НЕГО БОЙ НЕ ЗАКАНЧИВАЕТСЯ ВООБЩЕ. Сопротивление сперва не зависело
 * от сил, и вышел тупик: щука 1.5 кг при подмотке 1.5 м/с упиралась на 29 Н
 * при фрикционе в 2 кг — шпуля сдавала всегда, и рыба не приближалась ни на
 * метр ни за минуту, ни за пять. Выдохнуться ей это не мешало: упирается-то
 * не она, а вода.
 *
 * Держаться поперёк потока — работа, и на неё нужны силы. Кончились — рыбу
 * разворачивает носом вперёд, и она идёт за леской обтекаемо: это ровно то,
 * что видно на экране, когда она ложится на бок. Отсюда и конец боя:
 * измотал — повела, и подмотка начинает выигрывать.
 */
const TOW_CD_SPENT = 0.15;
/**
 * Боковая площадь рыбы в долях квадрата длины. Середина между глубоким
 * телом окуня (около 0.22·L²) и брёвнышком щуки (около 0.12·L²).
 */
const TOW_AREA_FRAC = 0.15;
/**
 * Сопротивление, с которым рыба идёт за леской, Н.
 *
 * ⚠️ ЭТО ТА САМАЯ РОВНАЯ НАГРУЗКА, КОТОРОЙ НЕ ХВАТАЛО, И ЕЁ ОТСУТСТВИЕ
 * ЛОМАЛО СРАЗУ ДВЕ ВЕЩИ.
 *
 * Замерено на окуне 580 г при фрикционе 2 кг: натяжение ходило от 1.5 до
 * 5.6 Н и обратно каждые восемь секунд — то есть вчетверо, — потому что
 * ЕДИНСТВЕННЫМ источником нагрузки была рывковая часть (см. fightForceN).
 * Между заходами бланк распрямлялся почти начисто, и снаружи это читалось
 * как пульсация снасти: тянет — отпустило — тянет.
 *
 * Вторая половина той же дыры: щуку крупнее килограмма можно было спокойно
 * вымотать ручкой, потому что сопротивляться подмотке ей было НЕЧЕМ. Тяга
 * рыбы гнула бланк, но выбирать леску не мешала совсем.
 *
 * На воде между рывками нагрузка не пропадает: рыбу ВОЛОКУТ через воду, и
 * вода этому сопротивляется. Сила квадратична по скорости подмотки и растёт
 * как квадрат длины, то есть как масса в степени 2/3, — поэтому мелочь
 * идёт за спиннингом легко, а трофей упирается так, что шпуля сдаёт.
 *
 * ⚠️ СКОРОСТЬ БЕРЁТСЯ КОМАНДНАЯ — ТА, ЧТО ВЫСТАВИЛ ИГРОК. Не «с какой
 * рыба приближается»: та зависит от натяжения, натяжение от неё, и петля
 * замкнулась бы. Здесь же вход, который ни от чего в снасти не зависит.
 *
 * ⚠️ ПОТОЛОК — СОБСТВЕННАЯ СИЛА РЫБЫ. Подмотка идёт до двух метров в
 * секунду, а квадрат на верхнем краю дал бы сотню ньютонов на щуке — снасть
 * рвалась бы от одного вращения ручки. Упереться сильнее, чем она способна
 * тянуть сама, рыба не может: дальше её просто волочёт.
 */
export function towDragN(spec, massKg, towMps, fresh) {
    const f = Math.max(0, Math.min(1, fresh));
    const cd = TOW_CD_SPENT + (TOW_CD - TOW_CD_SPENT) * f;
    const l = lengthFor(spec, massKg);
    const area = TOW_AREA_FRAC * l * l;
    const drag = 0.5 * WATER_RHO * cd * area * towMps * towMps;
    return Math.min(drag, ownForceN(spec, massKg));
}
/**
 * Насколько эта рыба крупна для своего вида. Единица — типичная.
 *
 * По ней идёт всё, что должно отличать мелочь от трофея: как быстро рвётся
 * дырка от крючка, как сильно бьёт свечка, с какого расстояния удаётся
 * подвести.
 */
export function sizeFactor(spec, massKg) {
    return Math.max(0.25, Math.min(3, massKg / spec.typicalKg));
}
//# sourceMappingURL=fish.js.map